module.exports = __webpack_public_path__ + "img/other_mobile_money.cebf176e.png";